import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type ResendPartnerInviteInput = {
  partnerId: string;
  partnerUserId: string;
};

// POST /api/partners/:id/users/:userId/resend
//
// Expires any pending invites for this partner_user and mints a fresh
// token. Server dispatches PARTNER_INVITED via c.executionCtx.waitUntil.
export function useResendPartnerInvite() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, ResendPartnerInviteInput>({
    mutationFn: ({ partnerId, partnerUserId }) =>
      apiFetch<{ ok: true }>(`/partners/${partnerId}/users/${partnerUserId}/resend`, {
        method: "POST",
      }),
    onSuccess: (_data, { partnerId }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.partners.users(partnerId) });
    },
    onError: (err) => {
      if (err.code === "already_accepted") {
        toast.error("This user has already accepted — no invite to resend.");
        return;
      }
      toast.error(err.message ?? "Failed to resend invite");
    },
  });
}
